module.exports = __webpack_public_path__ + "img/project_max_green.0fcdfc87.svg";